<template>
  <v-navigation-drawer
    v-if="$store.getters.isAuthenticated"
    v-bind:value="drawer"
    v-on:change="$emit('drawer', drawer)"
    :mini-variant.sync="mini"
    fixed
    app
    class="nowrap"
  >
    <v-list dense nav>
      <v-list-item>
        <GlobalSearchInput> </GlobalSearchInput>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list nav>
      <div v-for="item in navDrawerItemsForUser" :key="item.key">
        <v-list-item v-if="!item.group" :to="item.to" router exact>
          <v-list-item-icon>
            <v-icon small>
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title class="text-body-2">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
        <v-list-group v-else>
          <template #prependIcon>
            <!-- <v-icon>item.icon</v-icon> -->
            <v-icon small>{{ item.icon }}</v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-title class="text-body-2">
              {{ item.title }}</v-list-item-title
            >
          </template>
          <v-list-item
            class="ml-5"
            v-for="subItem in filter(item.subItems)"
            :key="subItem.key"
            :to="subItem.to"
            router
            exact
            v-show="drawer"
          >
            <v-list-item-icon>
              <v-icon small>
                {{ subItem.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-body-2">
              {{ subItem.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </div>
    </v-list>
    <v-divider></v-divider>
    <v-list v-if="$store.getters.isAuthenticated" nav>
      <v-list-item @click="logout">
        <v-list-item-icon>
          <v-icon> mdi-logout </v-icon>
        </v-list-item-icon>
        <v-list-item-title> Log Out </v-list-item-title>
      </v-list-item>
    </v-list>
    <v-list v-else nav>
      <v-list-item to="login">
        <v-list-item-icon>
          <v-icon> mdi-login </v-icon>
        </v-list-item-icon>
        <v-list-item-title> Login </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import GlobalSearchInput from "./Search/GlobalSearchInput.vue";

export default {
  components: {
    GlobalSearchInput,
  },
  props: {
    drawer: {
      typeof: String,
      required: true,
    },
  },
  data() {
    return {
      mini: this.$vuetify.breakpoint.mdAndDown,
      navDrawerItems: [
        {
          key: 0,
          title: "Home",
          to: { name: "Home" },
          icon: "mdi-home",
          action: "ESVOverview",
          subject: "Home",
        },
        {
          key: 1,
          title: "Documents",
          icon: "mdi-earth",
          group: true,
          subItems: [
            {
              key: 1.1,
              title: "Overview",
              to: { name: "Overview" },
              icon: "mdi-bookmark",
              action: "ESVOverview",
              subject: "Home",
            },
            {
              key: 1.2,
              title: "Serial Search",
              to: { name: "SerialSearch" },
              icon: "mdi-magnify",
              action: "SerialSearch",
              subject: "SerialNr",
            },
            {
              key: 1.3,
              title: "Advanced Search",
              to: { name: "AdvancedSearch" },
              icon: "mdi-magnify",
              action: "GeneralSearch",
              subject: "AdvancedSearch",
            },
            {
              key: 1.4,
              title: "Under preparation",
              to: { name: "UnderPreparation" },
              icon: "mdi-chart-bar",
              action: "Overview",
              subject: "UnderPreparation",
            },
          ],
        },
        {
          key: 2,
          title: "Administration",
          icon: "mdi-cog",
          group: true,
          subItems: [
            {
              key: 2.1,
              title: "Users",
              to: { name: "Users" },
              icon: "mdi-account-group",
              action: "Overview",
              subject: "Profile",
            },
            {
              key: 2.2,
              title: "Organisations",
              to: { name: "Organisations" },
              icon: "mdi-office-building",
              action: "Overview",
              subject: "Organisation",
            },

            {
              key: 2.3,
              title: "Models",
              to: { name: "Models" },
              icon: "mdi-view-grid",
              action: "Overview",
              subject: "Model",
            },
            {
              key: 2.4,
              title: "Parts",
              to: { name: "Parts" },
              icon: "mdi-view-grid",
              action: "Overview",
              subject: "Part",
            },
            {
              key: 2.5,
              title: "Service Request Types",
              to: { name: "ServiceRequestTypes" },
              icon: "mdi-auto-fix",
              action: "Overview",
              subject: "ServiceRequestType",
            },
            {
              key: 2.6,
              title: "Locked ESV",
              to: { name: "LockedESV" },
              icon: "mdi-safe-square-outline",
              action: "Overview",
              subject: "LockedESV",
            },
            // { // this doesn't work on old Daikin, so no need to implement yet
            //   key: 2.7,
            //   title: "Export Units To CRM",
            //   // to: { name: "DuplicateModels" },
            //   icon: "mdi-laptop",
            //   action: 'ExportToCRM', subject: 'Units'
            // },
            {
              key: 2.8,
              title: "Login history",
              to: { name: "LogAlternativeLogins" },
              icon: "mdi-eye",
              action: "Overview",
              subject: "AlternativeLogins",
            },

            // {
            //   key: 2.9,
            //   title: "IP White List",
            //   to: { name: "IPWhiteList" },
            //   icon: "mdi-playlist-check",
            //   action: 'Overview', subject: 'IPWhiteList'
            // },
          ],
        },
        {
          key: 3,
          title: "Translations",
          to: { name: "Translations" },
          icon: "mdi-google-translate",
          action: "Overview",
          subject: "Translations",
        },
        {
          key: 4,
          title: "Input",
          icon: "mdi-pencil",
          // action: 'DisplayAll', subject: 'Translations',
          group: true,
          subItems: [
            {
              key: 4.1,
              title: "Create document",
              icon: "mdi-file-document-edit",
              to: { name: "Create" },
              action: "Create",
              subject: "Navbar",
            },
            {
              key: 4.2,
              title: "Copy document",
              icon: "mdi-content-copy",
              to: { name: "Copy" },
              action: "Copy",
              subject: "Navbar",
            },
            {
              key: 4.3,
              title: "In Progress",
              icon: "mdi-archive",
              to: { name: "InProgress" },
              action: "Overview",
              subject: "InProgress",
            },
            {
              key: 4.4,
              title: "ESV Situations",
              icon: "mdi-chart-bar",
              to: { name: "ESVSituations" },
              action: "Overview",
              subject: "ESVSituations",
            },
          ],
        },
        {
          key: 5,
          title: "Publish",
          icon: "mdi-thumb-up",
          // action: 'SubMenu', subject: 'Publish',
          group: true,
          subItems: [
            {
              key: 5.1,
              title: "To Be Approved",
              icon: "mdi-flag",
              to: { name: "ToBeApproved" },
              action: "Overview",
              subject: "ToBeApproved",
            },
            {
              key: 5.2,
              title: "To Be Distributed",
              icon: "mdi-flag",
              to: { name: "ToBeDistributed" },
              action: "Overview",
              subject: "ToBeDistributed",
            },
          ],
        },
        {
          key: 6,
          title: "Analytics",
          icon: "mdi-chart-line",
          // action: 'SubMenu', subject: 'Analytics',
          group: true,
          subItems: [
            {
              key: 6.1,
              title: "Logged updates",
              icon: "mdi-message",
              to: { name: "LoggedUpdates" },
              action: "Overview",
              subject: "LoggedUpdates",
            },
            {
              key: 6.2,
              title: "Google Analytics",
              icon: "mdi-google",
              to: { name: "GoogleAnalytics" },
              action: "Overview",
              subject: "Analytics",
            },
          ],
        },
        {
          key: 7,
          title: "Help",
          icon: "mdi-help",
          to: { name: "Help" },
        },
        {
          key: 8,
          title: "Release Notes",
          icon: "mdi-information",
          to: { name: "ReleaseNotes" },
        },
        {
          key: 9,
          title: "ECare",
          icon: "mdi-heart-pulse",
          group: true,
          subItems: [
            {
              key: 9.1,
              title: "Communication rules",
              icon: "mdi-bullhorn",
              to: { name: "CommunicationRules" },
              action: "Overview",
              subject: "CommunicationRules",
            },
            {
              key: 9.2,
              title: "API Logs",
              icon: "mdi-file-code",
              to: { name: "ECareLogs" },
              action: "Overview",
              subject: "ECareLogs",
            },
          ],
        },
      ],
    };
  },
  computed: {
    navDrawerItemsForUser() {
      return this.navDrawerItems.filter(
        (item) => {
          if (item.group) {
            return (
              item.subItems.filter(
                (si) => !si.action || this.$can(si.action, si.subject)
              ).length > 0
            );
          } else {
            return !item.action || this.$can(item.action, item.subject);
          }
        }

        // (item) => (!item.group && (!item.action || this.$can(item.action, item.subject)) || item.subItems.filter(si => !si.action || this.$can(si.action, si.subject)).length > 0)// !item.role || this.$store.getters.isInRole(item.role)
      );
    },
  },
  methods: {
    filter(items) {
      return items.filter(
        (item) => !item.action || this.$can(item.action, item.subject) // !item.role || this.$store.getters.isInRole(item.role)
      );
    },
    routeTo(routeName) {
      this.$router.push({ name: routeName });
    },
    logout() {
      // this.$store.commit("logout");
      this.$emit("logout");
    },
  },
};
</script>
